//store a token in local storage
export const setItem = (key, value) => {
  JSON.stringify(sessionStorage.setItem(`@${key}`, value))
}
// get a token from local storage
export const getItem = (key) => {
  return sessionStorage.getItem(`@${key}`)
}
// remove a token from local storage
export const removeItem = (key) => {
  sessionStorage.removeItem(`@${key}`)
}
